import React, { Component } from 'react';
import Nouislider from 'nouislider-react';
import PropTypes from 'prop-types';
import 'nouislider/distribute/nouislider.css';

class RangeSlider extends Component {
  state = {
    value: 0,
  };

  setValue = value => {
    this.setState({
      value: value,
    });
  };

  componentDidUpdate() {
    const { value } = this.state;
    const { slidePoints } = this.props;
    if (!value && slidePoints.length > 0) {
      this.setValue(slidePoints[0]);
    }
  }

  onSlide = (render, handle, value) => {
    let wardrobe = [...this.props.wardrobesConfigs];
    if (wardrobe.length === 0) {
      this.setValue(value);
      this.props.changeSize(value);
    } else {
      wardrobe[this.props.activeWardrobe].accessories = {
        left: [],
        center: [],
        right: [],
      };
      if (this.props.setWardrobesConfigs) {
        this.props.setWardrobesConfigs(wardrobe);
      }

      this.setValue(value);
      this.props.changeSize(value);
    }
  };

  sortSteps = stepsArr => {
    return stepsArr.sort((x, y) => {
      return x - y;
    });
  };

  setRangeSteps = pointsArr => {
    const rangeSteps = {};
    const arr = [...pointsArr];
    arr.shift();
    const stepsAmount = Math.round(100 / arr.length);

    for (let i = 0; i < arr.length; i++) {
      if (i === arr.length - 1) {
        rangeSteps['100%'] = arr[i];
      } else {
        rangeSteps[`${stepsAmount * (i + 1)}%`] = arr[i];
      }
    }
    return rangeSteps;
  };

  render() {
    const { value } = this.state;
    const { activeValue, slidePoints, sliderName, unit } = this.props;
    let steps, points;

    if (slidePoints.length > 0) {
      points = this.sortSteps(slidePoints);
      steps = this.setRangeSteps(points);
    }

    return (
      <div className="range-slider">
        <div className="range-slider__text">
          <p className="range-slider__title">{sliderName}</p>
          {!!value && (
            <p className="range-slider__value">
              {activeValue} {unit}
            </p>
          )}
        </div>
        {slidePoints.length > 0 && (
          <Nouislider
            start={activeValue}
            connect="lower"
            snap
            range={{
              min: points[0],
              ...steps,
              max: points[points.length - 1],
            }}
            onSlide={this.onSlide}
          />
        )}
      </div>
    );
  }
}

RangeSlider.propTypes = {
  slidePoints: PropTypes.array,
  sliderName: PropTypes.string,
  unit: PropTypes.string,
};

export default RangeSlider;
